import Loading from '../../../Common/Loading';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';
import { TableRegistersHoseHoldByTeam } from './TableRegistersHoseHoldByTeam';
import { RegistersHoseHoldByHealthUnit } from './RegistersHoseHoldByHealthUnit';
import { TableRegistersHoseHoldByHealthUnit } from './TableRegistersHoseHoldByHealthUnit';
import { RegistersHoseHoldByTeam } from './RegistersHoseHoldByTeam';
import RegistersHouseHoldByCoordinates from './RegistersHouseHoldByCoordinates';

export const Charts = () => {
    const { isLoading } = useMappingChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <RegistersHoseHoldByHealthUnit />
                <RegistersHoseHoldByTeam />
            </div>
            <div className="charts-side-by-side-dashboards">
                <TableRegistersHoseHoldByHealthUnit />
                <TableRegistersHoseHoldByTeam />
            </div>
            <div className="charts-side-by-side-dashboards">
                <RegistersHouseHoldByCoordinates />
            </div>
        </>
    );
};
